<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ets8B3/tc-custom/9781480477094.jpg?1707592312085" alt="This image is the cover for the book Marriage Under the Terror"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marriage Under the Terror
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning debut from one of Britain’s most cherished crime writers</b><br/>Before she created the iconic Miss Silver, Patricia Wentworth found acclaim as an author of page-turning romances. Set during the French Revolution, <i>A Marriage Under the Terror</i> is a gripping tale of love blossoming in the ashes of betrayal, and a fascinating first step from a master storyteller.<br/>Nineteen-year-old orphan Aline de Rochambeau is horrified at the prospect of an arranged marriage to the foppish Vicomte Selincourt. But when Selincourt and Madame de Montargis, Aline’s married aunt, are unmasked as lovers and arrested for treason, the young noblewoman’s situation grows even more drastic. Alone in a Paris engulfed in revolt, Aline has no chance of survival—until she meets the dashing freedom fighter Jacques Dangeau. Torn between his vow to liberate France and his passion for Aline, Jacques makes a choice that could doom both of them forever.<br/>Published in 1910, <i>A Marriage Under the Terror</i> won the Melrose Prize for best first novel.<br/><br/>This ebook has been professionally proofread to ensure accuracy and readability on all devices.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia  Wentworth
      </h2>
      
      <p class="authorDescription body article">Patricia Wentworth (1878&ndash;1961) was one of the masters of classic English mystery writing. Born in India as Dora Amy Elles, she began writing after the death of her first husband, publishing her first novel in 1910. In the 1920s, she introduced the character who would make her famous: Miss Maud Silver, the former governess whose stout figure, fondness for Tennyson, and passion for knitting served to disguise a keen intellect. Along with Agatha Christie&rsquo;s Miss Marple, Miss Silver is the definitive embodiment of the English style of cozy mysteries.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?81344390